import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	giveProductFeedback: {
		id: 'polaris-components.view-header.feedback-button.give-product-feedback',
		defaultMessage: 'Give product feedback',
		description: 'Give product feedback button in the view header',
	},
});
